<template>
  <div>
    <el-row style="margin-bottom: -20px;">
      <h4>客户名称：{{ customerName }}</h4>
      <h4>项目点名称：{{ projectName }}</h4>
    </el-row>
    <el-row>
      <el-col>
        <el-form v-model="searchForm" :ref="searchForm" :inline="true" style="margin-top: 20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.PRODUCT_CODE"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" v-preventReClick @click="queryTableData">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addNewProduct" v-if="userPriceType == 2 && customerStatus !== 1">
          上架产品
        </el-button>
        <el-button size="medium" @click="commodityBindForm">批量绑定供应商</el-button>
        <el-button size="medium" @click="importPrice" v-if="userPriceType == 2 && customerStatus !== 1">导入价格</el-button>
        <el-button size="medium" type="primary" plain @click="exportPriceChooseDay" v-if="userPriceType == 2">
          导出价格
        </el-button>
        <el-button size="medium" @click="同步团餐公司供应产品()" v-if="fun_dic[107000301] && 客户订单类型 == 2">
          同步团餐公司供应产品
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="margin-top: 20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品名称" prop="ALIAS_NAME"></el-table-column>
          <el-table-column label="产品代码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="价格" prop="PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="价格" prop="PRICE" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="开始日期" prop="START_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="结束日期" prop="END_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="出库方式" prop="OW_TYPE" v-if="userPriceType == 2">
            <template slot-scope="scope">
              <el-tag>{{ showOutType[scope.row.OW_TYPE] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="供货商" prop="VENDOR_NAME"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="openMatch(scope.row)" type="text" v-if="userPriceType == 1">匹配供货商</el-button>
              <!-- <el-button type="text" @click="updateOthData(scope.row)" v-if="userPriceType == 2">修改出库方式</el-button> -->
              <el-button type="text" @click="updatePriData(scope.row)"
                v-if="userPriceType == 2 && customerStatus !== 1">修改销售价</el-button>
              <el-button type="text" v-show="userPriceType == 2 && customerStatus !== 1" @click="downData(scope.row)"
                style="color:#F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="matchFormDialog" @close="matchFormDialog = false" title="匹配采购供货商"
      :close-on-click-modal="false" width="350px" center>
      <el-form size="small" ref="matchForm" v-model="matchForm">
        <el-form-item label="供货商：">
          <el-select filterable v-model="matchForm.TC_COMPANY" placeholder="请选择供货商" :clearable="true">
            <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button v-preventReClick class="operate-btn" @click="matchFormDialog = false">取消</el-button>
        <el-button v-preventReClick class="operate-btn" @click="submitMatch">确认</el-button>
      </div>
    </el-dialog>
    <!-- 修改销售价 -->
    <el-dialog title="修改销售价" center :visible.sync="editFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" style="margin-top: 0" :rules="rules">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          {{ editForm.ALIAS_NAME }}
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth">
          {{ editForm.TYPE_UNIT }}
        </el-form-item>
        <el-form-item label="销售价：" :label-width="formLabelWidth" prop="PRICE">
          <el-input v-model="editForm.PRICE" @change="changCurPrice" style="width: 85%"></el-input>
        </el-form-item>
        <el-form-item label="开始日期：" :label-width="formLabelWidth" prop="START_DAY">
          <label slot="label">开&nbsp;始&nbsp;日&nbsp;期：</label>
          <el-date-picker v-model="editForm.START_DAY" :clearable="false" :picker-options="pickerOptions" type="date"
            style="width: 85%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" :label-width="formLabelWidth" prop="END_DAY">
          <label slot="label">结&nbsp;束&nbsp;日&nbsp;期：</label>
          <el-date-picker v-model="editForm.END_DAY" :clearable="false" :picker-options="pickerOptions" type="date"
            style="width: 85%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button :loading="loading1" @click="submitAdd('editForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入商品绑定信息 -->
    <el-dialog title="导入商品信息" center :visible.sync="importCommodityFormVisible" width="500px"
      :close-on-click-modal="false">
      <el-form ref="importCommodityForm" v-model="importCommodityForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleCommoditySuccess"
          :on-remove="handleCommodityRemove" :name="this.importCommodityForm.commodityName" multiple
          accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadCommodityTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeImportCommodityForm">取 消</el-button>
        <el-button size="small" :loading="loadImport" @click="submitCommodityEnter">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入报价 -->
    <el-dialog title="导入价格" center :visible.sync="importPriceFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="importPriceForm" :model="importPriceForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.importPriceForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadPriceTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="close('importPriceForm')" disabled>取 消</el-button> -->
        <el-button size="small" @click="close('importPriceForm')">取 消</el-button>
        <el-button size="small" @click="submitPrice('importPriceForm')" :loading="loading1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改出库方式 -->
    <el-dialog title="修改出库方式" center :visible.sync="editOthFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="editOthForm" ref="editOthForm" style="margin-top: 0" :rules="rules1">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          {{ editOthForm.ALIAS_NAME }}
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth">
          {{ editOthForm.TYPE_UNIT }}
        </el-form-item>
        <el-form-item label="出库方式：" :label-width="formLabelWidth" prop="OW_TYPE">
          <el-select v-model="editOthForm.OW_TYPE" style="width: 85%" @change="changOW_TYPE">
            <el-option v-for="item in wayOut" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商：" :label-width="formLabelWidth" prop="VENDOR_ID">
          <label slot="label">供&nbsp;&nbsp;应&nbsp;&nbsp;商：</label>
          <el-select v-if="editOthForm.OW_TYPE === 2 || owTypeStatus === 2" disabled @change="changGYS"
            v-model="editOthForm.VENDOR_ID" style="width: 85%" clearable>
            <el-option v-for="item in GYS_LIST" :key="item.VENDOR_ID" :label="item.VENDOR_NAME" :value="item.VENDOR_ID">
            </el-option>
          </el-select>
          <el-select v-else @change="changGYS" v-model="editOthForm.VENDOR_ID" style="width: 85%" clearable>
            <el-option v-for="item in GYS_LIST" :key="item.VENDOR_ID" :label="item.VENDOR_NAME" :value="item.VENDOR_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购价：" :label-width="formLabelWidth">
          <label slot="label">采&nbsp;&nbsp;购&nbsp;&nbsp;价：</label>
          <el-input v-model="GYS_PRICR" disabled style="width: 85%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editOthForm')">取 消</el-button>
        <el-button :loading="loading" @click="submitEdit('editOthForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--    --------------------------------  导出价格-->
    <el-dialog title="选择导出日期范围" center :visible.sync="importFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="importForm" ref="importForm" style="margin-top: 0">
        <el-form-item label="日期范围：">
          <el-date-picker size="medium" v-model="importForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('importForm')">取 消</el-button>
        <el-button @click="importOutPrice('importForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { haveGYSFun } from 'api/shopOrderManage';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      carryForm: {},
      carryRow: {},
      carryFormDialog: false,
      file_name: '',
      fileList: [],
      tableData: [],
      searchForm: {},
      currentPage: 1,

      PAGE_ID: '1070003', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        107000301: 0,
      },
      pageSize: 10,
      totalCount: 0,
      companys: [],
      matchForm: {},
      matchFormDialog: false,
      importCommodityFormVisible: false,
      importCommodityForm: {
        commodityName: 'tmp',
      },
      loadImport: false,
      importPriceFormVisible: false,
      importPriceForm: {
        file: 'tmp',
      },
      url: '',
      loading: false,
      loading1: false,
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      客户订单类型: sessionStorage.getItem('customerStatus'),
      showOutType: ['默认', 'MTO', 'MTS', 'DS'],
      editOthFormVisible: false,
      editOthForm: {},
      rules1: {
        OW_TYPE: [
          { required: true, message: '请选择出库方式', trigger: 'blur' },
        ],
        VENDOR_ID: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
      },
      rules: {
        PRICE: [
          { required: true, message: '请输入价格', trigger: 'blur' },
        ],
        SALE_NEXT_EFFECTIVE_DATE: [
          { required: true, message: '请选择生效日期', trigger: 'blur' },
        ],
      },
      formLabelWidth: '110px',
      wayOut: [
        {
          ID: 1,
          NAME: 'MTO',
        }, {
          ID: 2,
          NAME: 'MTS',
        }, {
          ID: 3,
          NAME: 'DS',
        },
      ],
      owTypeStatus: 0, // 出库方式状态
      GYS_LIST: [],
      GYS_PRICR: '',
      importForm: {},
      importFormVisible: false,
      editFormVisible: false,
      editForm: {},
      pickerOptions: {},
      TC_STATUS: 0,
      customerStatus: Number(sessionStorage.getItem('customerStatus')),
      customerName: sessionStorage.getItem('customerName') || '',
      projectName: sessionStorage.getItem('projectName') || '',
    };
  },
  methods: {
    同步团餐公司供应产品() {
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 30,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PROJECT_ID: sessionStorage.getItem('projectId'),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '同步成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    queryTableData() {
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 10,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PROJECT_ID: sessionStorage.getItem('projectId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        PRICE_MODE: this.userPriceType,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        if (result) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.loading = false;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // -----------------------打开导出价格框
    exportPriceChooseDay() {
      this.importFormVisible = true;
    },
    openMatch(row) {
      this.matchFormDialog = true;
      this.matchForm = row;
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTableData();
    },
    queryCustomer() {
      const params = {};
      haveGYSFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].list;
            this.customers = result[0].list;
          } else {
            this.companys = [];
            this.customers = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    submitMatch() {
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 21,
        INNER_ID: this.matchForm.ID,
        VENDOR_ID: this.matchForm.TC_COMPANY,
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '匹配成功', type: 'success' });
          this.matchFormDialog = false;
          this.queryTableData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 打开商品绑定模态框
    commodityBindForm(row) {
      this.importCommodityFormVisible = true;
      // this.projectID = row.ID
    },
    // 关闭商品绑定模态框
    closeImportCommodityForm() {
      this.importCommodityFormVisible = false;
    },
    // 导入商品提交
    submitCommodityEnter() {
      const params = {
        PROJECT_ID: sessionStorage.getItem('projectId'),
        FILE_NAME: this.file_name,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PRICE_MODE: Number(sessionStorage.getItem('PRICE_MODE')),
        SERVICE_ID: '10041',
        OTYPE: 15,
      };
      this.loadImport = true;
      http.post(params)
        .then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
          } else {
            this.$message.show({ text: '部分导入失败，请注意下载文件', type: 'error' });
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          }
          this.fileList = [];
          this.queryTableData();
          this.loadImport = false;
          this.importCommodityFormVisible = false;
        }).catch((error) => {
          this.loadImport = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导入商品绑定的下载模板
    downLoadCommodityTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pm2zzvpp.xlsx';
    },
    handleCommoditySuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleCommodityRemove(file, fileList) {
      this.fileList = [];
    },
    // 导入价格
    importPrice() {
      this.importPriceFormVisible = true;
    },
    // 导入价格模板
    downLoadPriceTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pm2ProjectPriceTemp.xls';
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    // 关闭弹窗
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.fileList = [];
      this.queryTableData();
    },
    submitPrice() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      // 执行代码
      const params = {
        FILE_NAME: this.url,
        PROJECT_ID: sessionStorage.getItem('projectId'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        SERVICE_ID: '10041',
        OTYPE: 16,
      };
      this.loading1 = true;
      // this.cancelDisable = true
      http.post(params).then((result) => {
        if (result[0].FILE_PATH) {
          this.$message.show({ text: '部分导入失败，请注意下载文件', type: 'warning' });
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '导入成功', type: 'success' });
        }
        this.loading1 = false;
        document.body.style.cursor = 'default';
        this.close('importPriceForm');
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading1 = false;
        // this.cancelDisable = false
        document.body.style.cursor = 'default';
      });
    },
    importOutPrice() {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 17,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PROJECT_ID: sessionStorage.getItem('projectId'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PRICE_MODE: this.userPriceType,
      };
      if (this.importForm.DAY_INTERVAL) {
        [params.START_DAY, params.END_DAY] = this.importForm.DAY_INTERVAL;
      }
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          this.importFormVisible = false;
          this.queryTableData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 修改出库方式
    updateOthData(row) {
      this.queryGYS(row.PRODUCT_CODE);
      this.editOthFormVisible = true;
      this.editOthForm = row;
      this.GYS_PRICR = row.CURRENT_BUY_PRICE;
      // this.other_name = row.PRODUCT_NAME;
    },
    // 修改的出库方式
    changOW_TYPE(e) {
      this.owTypeStatus = e;
    },
    // 获取相应采购价
    changGYS(e) {
      if (e === '') {
        this.editOthForm.VENDOR_ID = 0;
      } else {
        let obj = {};
        obj = this.GYS_LIST.find((item) => item.VENDOR_ID === e);
        this.GYS_PRICR = obj.PRICE;
      }
    },
    // 拉取供应商
    queryGYS(e) {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 19,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: e,
      };
      http.post(params).then((result) => {
        this.GYS_LIST = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10041',
            OTYPE: 18,
            PROJECT_ID: Number(sessionStorage.getItem('projectId')),
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            PRODUCT_CODE: this.editOthForm.PRODUCT_CODE,
            OW_TYPE: this.editOthForm.OW_TYPE,
            VENDOR_ID: this.editOthForm.VENDOR_ID,
            DETAIL_ID: this.editOthForm.ID,
            PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
          };
          this.loading = true;
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '修改成功', type: 'success' });
              this.editOthFormVisible = false;
              this.queryTableData();
              this.loading = false;
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.loading = false;
            });
        }
      });
    },
    updatePriData(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.zl_name = row.PRODUCT_NAME;
    },
    // 修改销售价
    changCurPrice(e) {
      if (!validation.价格正数验证(e)) {
        this.$message.show({ text: '请输入大于零的销售价', type: 'warning' });
      }
    },
    // 提交修改
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            SERVICE_ID: '10041',
            OTYPE: 20,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            PROJECT_ID: Number(sessionStorage.getItem('projectId')),
            PRODUCT_CODE: this.editForm.PRODUCT_CODE,
            START_DAY: this.editForm.START_DAY,
            END_DAY: this.editForm.END_DAY,
          };
          if (this.editForm.PRICE) {
            if (validation.价格正数验证(this.editForm.PRICE)) {
              params.PRICE = Number(this.editForm.PRICE);
            } else {
              this.$message.show({ text: '请输入大于零的价格', type: 'warning' });
              return false;
            }
          } else {
            this.$message.show({ text: '请输入价格', type: 'warning' });
            return false;
          }
          this.loading1 = true;
          http.post(params)
            .then((result) => {
              this.editFormVisible = false;
              this.$message.show({ text: '修改成功', type: 'success' });
              this.queryTableData();
              this.loading1 = false;
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.loading1 = false;
            });
        }
      });
    },
    // 删除
    downData(row) {
      this.$confirm('您确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 21,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          PROJECT_ID: Number(sessionStorage.getItem('projectId')),
          DETAIL_ID: row.ID,
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryTableData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      });
    },
    addNewProduct() {
      this.$router.push({ name: 'addProjectProduct' });
    },
  },
  created() {
    this.queryBeforeFun();
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryTableData();
    this.queryCustomer();
  },
};
</script>
<style scoped>
.el-row>>>h4 {
  display: inline-block;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/customerManage/projectProduct.vue